import React from 'react';
import { Platform } from 'react-native';
import { Link } from 'expo-router';
import { useAuthStore } from '@/store/auth';
import SidebarListItemLayout from './SidebarListItemLayout';
export default function SidebarPluginsLink({ pathname, navigation, Item, colors }) {
  const visible = useAuthStore(state => !!state.user?.id && !state.user?.flags?.isGhost);
  if (Platform.OS !== 'macos' || !visible) return null;
  if (navigation && Item) return <Item label="Plugins" icon="puzzle-piece" colors={colors} isActive={pathname === '/plugins'} onPress={() => navigation.navigate('plugins')} />;
  return <Link href="/plugins" asChild withAnchor><SidebarListItemLayout id="plugins" title="Plugins" icon="puzzle-piece" isActive={pathname === '/plugins'} noEllipsis /></Link>;
}
